/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPurchaseRequest as AgentApiContractAddPurchaseRequest } from '../../models/AgentApi/Contract/add-purchase-request';
import { AddPurchaseResponse as AgentApiContractAddPurchaseResponse } from '../../models/AgentApi/Contract/add-purchase-response';

export interface ApiAgentAddPurchasePost$Params {

/**
 * * Interface language
 */
  lang?: string;
      body?: AgentApiContractAddPurchaseRequest
}

export function apiAgentAddPurchasePost(http: HttpClient, rootUrl: string, params?: ApiAgentAddPurchasePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPurchaseResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddPurchasePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAddPurchaseResponse>;
    })
  );
}

apiAgentAddPurchasePost.PATH = '/api/Agent/AddPurchase';
